export default __webpack_public_path__ + "8076511a459196a1cf6f00984c06eaca.png";